import { api2 } from "../controllers/api";
export const resendSettlementLinkAPI = async (payload) => {
  try {
    const url = `/notifications/settlement`;
    const result = await api2.post(url, payload);
    return result;
  } catch (error) {
    throw error;
  }
};
export const getNotificationsListAPI = async (query) => {
  try {
    const url = `/notifications/?${query ? query : ""}`;
    const result = await api2.get(url);
    return result;
  } catch (error) {
    throw error;
  }
};
export const updateNotificationStatusAPI = async (data) => {
  try {
    const url = `/notifications/`;
    const result = await api2.put(url, data);
    return result;
  } catch (error) {
    throw error;
  }
};

export const sendWhatsappMessageAPI = async (payload) => {
  try {
    const url = `/notifications/commsFromFE`;
    const result = await api2.post(url, payload);
    return result;
  } catch (error) {
    throw error;
  }
};

export const variousCommsTemplatesAPI = async (payload) => {
  try {
    const url = `/notifications/variousCommsTemplates`;
    const result = await api2.get(url, payload);
    return result;
  } catch (error) {
    throw error;
  }
};
